export const OPEN_MODAL_CREATE_NEW_THEAD = 'OPEN_MODAL_CREATE_NEW_THEAD';
export const CLOSE_MODAL_CREATE_NEW_THEAD = 'CLOSE_MODAL_CREATE_NEW_THEAD';
export const SELECTED_THREAD_ACTION = 'SELECTED_THREAD_ACTION';
export const CHANGE_STATUS_EMPTY_CONVERSATION_LIST =
  'CHANGE_STATUS_EMPTY_CONVERSATION_LIST';
